import { ReducerBuilder } from 'typescript-fsa-reducers';

import { applyAsyncReducer } from '@utils';

import { authFetchCurrent } from './authFetchCurrent';

import { IAuthStore } from '../../types';
import { IActionAuthFetchCurrentPayloadDone } from './types';

export const authFetchCurrentReducer = (auth: ReducerBuilder<IAuthStore, IAuthStore>) => {
	applyAsyncReducer<IAuthStore['user']['data'], IAuthStore['user']['meta']>()(
		'user',
		'networkStatus',
		authFetchCurrent.async,
		auth,
		(props: { result: IActionAuthFetchCurrentPayloadDone }) => ({
			user: props.result.user,
		}),
	);
};
